import React from 'react';
import FieldServiceType from '../../Fields/ServiceType';

const Manual = (props) => (
  <>
    <FieldServiceType
      {...props}
    />
  </>
)

export default Manual;
